export default "__VITE_ASSET__B9$wwznW__"